import { useState } from "react";

const useStepsBehavior = steps => {
  const [step, setStep] = useState(0);
  const nextStep = () => {
    setStep(step + 1);
  };
  const previousStep = () => {
    if (step > 0) {
      setStep(step - 1);
    }
  };

  return { step, setStep, nextStep, previousStep, data: steps[step] };
};

export default useStepsBehavior;
